import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  email: Yup.string().required('validation.email').email('validation.email'),
  password: Yup.string().required('validation.password'),
});
